import { render } from "./SidebarLink.vue?vue&type=template&id=88a317b8&scoped=true"
import script from "./SidebarLink.vue?vue&type=script&lang=js"
export * from "./SidebarLink.vue?vue&type=script&lang=js"

import "./SidebarLink.vue?vue&type=style&index=0&id=88a317b8&scoped=true&lang=css"

import exportComponent from "E:\\dipto_projects\\parcel\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88a317b8"]])

export default __exports__